import * as React from 'react';
import Typography from '@mui/material/Typography';
import MuiModal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import {
  ModalRoot,
  ModalHeader as UiModalHeader,
  ModalFooter as UiModalFooter,
  ModalBody as UiModalBody,
  CloseButton as UiCloseButton
} from './styles';
import Slide from '@mui/material/Slide';
import cc from 'classcat';
import './styles.scss'; // fix interop with legacy
import { SxProps } from '@mui/material';

type ModalSectionProps = {
  children: React.ReactNode;
  sx?: any;
  isLegacy?: boolean;
};

type CloseButtonProps = {
  onClick: () => void;
  children?: React.ReactNode;
};

const ModalTitle = ({ children }: ModalSectionProps) => (
  <Typography data-attr="modal-title" fontWeight="400" variant="h4">
    {children}
  </Typography>
);

const ModalFooter = ({ children, isLegacy = true, sx }: ModalSectionProps) => (
  <UiModalFooter className={cc({ 'legacy-page': isLegacy })} sx={sx}>
    {children}
  </UiModalFooter>
);

const ModalBody = ({ children, sx, isLegacy = true }: ModalSectionProps) => (
  <UiModalBody
    className={cc({ 'modal__body common-style-for-scrollbar': true, 'legacy-page': isLegacy })}
    data-attr="modal-body"
    sx={sx}
  >
    {children}
  </UiModalBody>
);

const CloseButton = ({ onClick }: CloseButtonProps) => (
  <UiCloseButton onClick={onClick}>
    <CloseIcon />
  </UiCloseButton>
);

type ModalProps = {
  isOpen: boolean;
  className?: string;
  onRequestHide?: () => void;
  children: React.ReactNode | React.ReactNode[];
  isLegacy?: boolean;
  width?: number;
  sx?: SxProps;
};

const Modal = ({ children, className, isOpen, onRequestHide, isLegacy = false, width = 600 }: ModalProps) => (
  <MuiModal
    className={className}
    disableRestoreFocus
    disableAutoFocus
    open={isOpen}
    onClose={onRequestHide}
    sx={{
      width,
      left: `calc(50% - ${width / 2}px)`
    }}
  >
    <Slide direction="down" in={isOpen} mountOnEnter unmountOnExit>
      <ModalRoot className="modalContent" data-attr="modal-content">
        {children}
      </ModalRoot>
    </Slide>
  </MuiModal>
);

const ModalHeader = ({ children, sx }: ModalSectionProps) => {
  return (
    <UiModalHeader sx={sx} data-attr="modal-header">
      {children}
    </UiModalHeader>
  );
};

export { Modal, CloseButton as ModalClose, ModalHeader, ModalFooter, ModalBody, ModalTitle };
